import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "447",
  height: "240",
  fill: "none",
  viewBox: "0 0 447 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m395.142 60.805-73.7 99.16h73.7zm24.455 118.59v20.1q0 11.055 1.34 17.755 1.674 6.7 3.35 10.385 2.01 3.35 3.685 4.69 1.674 1.34 2.345 1.675h-44.89q.334-.335 2.01-1.675 1.674-1.34 3.35-4.69 1.674-3.685 3.015-10.385 1.34-6.7 1.34-18.09v-19.765h-108.54L419.597.84v159.125h26.8v19.43z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M282.938 133.5q0-28.476-4.355-49.245-4.355-20.77-11.725-34.17-7.035-13.736-16.415-20.1-9.045-6.366-18.76-6.365-9.045 0-17.42 5.695-8.375 5.36-14.74 16.415-6.364 10.72-10.05 27.47-3.685 16.415-3.685 38.525 0 28.475 4.355 49.245t11.39 34.17q7.37 13.4 16.415 20.1 9.38 6.365 19.43 6.365 9.045 0 17.085-5.36 8.375-5.361 14.74-16.08 6.365-10.72 10.05-27.135 3.685-16.75 3.685-39.53m26.13-16.08q0 28.81-6.03 51.59-5.695 22.445-15.745 38.19-10.05 15.41-23.785 23.785-13.735 8.04-29.48 8.04-15.075 0-28.475-7.035t-23.45-20.77-16.08-34.505q-5.695-20.77-5.695-47.905 0-29.146 5.695-51.925 6.03-23.115 16.08-38.525 10.05-15.745 23.45-23.785Q219.288 6.2 235.033 6.2q15.075 0 28.475 7.37 13.735 7.035 23.785 21.105t15.745 34.84q6.03 20.77 6.03 47.905"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m108.54 60.805-73.7 99.16h73.7zm24.455 118.59v20.1q0 11.055 1.34 17.755 1.675 6.7 3.35 10.385 2.01 3.35 3.685 4.69t2.345 1.675h-44.89q.335-.335 2.01-1.675t3.35-4.69q1.675-3.685 3.015-10.385t1.34-18.09v-19.765H0L132.995.84v159.125h39.607v19.43z"
    }, null, -1)
  ])))
}
export default { render: render }